export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Industrial Maintenance Educator — London, United Kingdom',
    'My students finally understand the difference between corrective and preventive maintenance, mechanical systems, electrical controls, and troubleshooting logic. I used to waste hours searching for the right way to explain how industrial maintenance actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain bearing alignment, motor control, hydraulic systems, reliability concepts, or how to teach diagnostic reasoning in maintenance contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Industrial Maintenance and Equipment Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated industrial maintenance projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Industrial Maintenance Educator | London, United Kingdom',
    "The material on mechanical systems and bearing maintenance completely changed how my students understand equipment reliability. They finally grasp how alignment and lubrication prevent failures. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Industrial Maintenance Teacher | Berlin, Germany',
    "The 50 industrial maintenance projects transformed how my students see real-world applications. Now they troubleshoot equipment problems, analyze failure patterns, understand predictive maintenance, and grasp why maintenance knowledge matters professionally and in real operations. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The industrial maintenance terminology handbook gave me back my class time. I used to spend time explaining maintenance concepts and misconceptions. Now I show the handbook and students instantly understand industrial maintenance concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Industrial Maintenance Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real equipment challenges, evaluating maintenance strategies, exploring failure causes, and understanding how maintenance analysis contributes to equipment reliability. This completely transformed how they see industrial maintenance.",
  ],
];
